import {
    Backpack,
    Bug,
    DotsThreeCircle,
    GraduationCap,
    Headphones,
    PersonArmsSpread,
    ShoppingCartSimple,
    User,
} from '@phosphor-icons/react';
import type {Icon} from '@phosphor-icons/react';

/**
 * L'icône d'un sujet, la même que dans l'application.
 *
 * Mêmes glyphes Phosphor, même graisse « light » : une demande doit se
 * reconnaître d'un écran à l'autre, du formulaire au back-office. La table
 * suit `topicIcon` côté Flutter (feedback_labels.dart) — les deux se
 * modifient ensemble.
 */
const ICONES: Record<string, Icon> = {
    // Deux lieux du menu plutôt que deux gestes : la boutique, où l'achat
    // échoue, et le sac à dos de « Mes méthodes », où il manque.
    purchase: Backpack,
    purchase_failed: ShoppingCartSimple,
    account: User,
    audio: Headphones,
    content: GraduationCap,
    crash: Bug,
    a11y: PersonArmsSpread,
    other_problem: DotsThreeCircle,
};

/**
 * Rien ne s'affiche sans sujet : les demandes d'avant les sujets n'ont que
 * leur catégorie, et une icône par défaut dirait quelque chose de faux.
 */
export const TopicIcon = ({topic, size = 18, className = ''}: {
    topic?: string;
    size?: number;
    className?: string;
}) => {
    const Icone = topic ? ICONES[topic] : undefined;
    if (!Icone) return null;
    return <Icone size={size} weight="light" className={className}/>;
};
